define((require) => {
    "use strict";

    require("array.prototype.find").shim();
});



// WEBPACK FOOTER //
// ./src/shared/util/ArrayFindPolyfill.js